export const PRIORITY_COUNTRIES = ["CH", "DE", "FR", "IT", "AT", "LI"];
export const COUNTRIES_TO_HIDE = ["UM", "BV", "IO", "YT", "HT", "BL", "TG"];
